import { Injectable, InjectionToken, signal, WritableSignal, inject } from '@angular/core';

export type AppTypes = 'main' | 'embed' | 'client' | '';

export const APP_TYPE = new InjectionToken<AppTypes>('');
export const TENANT_ID = new InjectionToken<string>('');

@Injectable({
  providedIn: 'root',
})
export class AppTypeService {
  readonly #type: WritableSignal<AppTypes> = signal('');
  type = this.#type.asReadonly();

  readonly #domain = signal('');
  domain = this.#domain.asReadonly();

  readonly #tenantId = signal('');
  tenantId = this.#tenantId.asReadonly();

  readonly #parentOriginUrl = signal('');
  parentOriginUrl = this.#parentOriginUrl.asReadonly();

  constructor() {
    const tenantId = inject<string>(TENANT_ID, { optional: true });
    const type = inject<AppTypes>(APP_TYPE, { optional: true });

    if (type) {
      this.#type.set(type);
    }

    if (tenantId) {
      this.#tenantId.set(tenantId);
    }
  }

  setType(type: AppTypes) {
    this.#type.set(type);
  }

  setDomain(domain: string) {
    this.#domain.set(domain);
  }

  setTenantId(tenantId: string) {
    this.#tenantId.set(tenantId);
  }

  setParentOriginUrl(parentOriginUrl: string) {
    this.#parentOriginUrl.set(parentOriginUrl);
  }
}
